import ProjectCard from "../PageLayout/ProjectCard";
import ProjectHeader from "../Projects/ProjectHeader";
import { ProjectType } from "../Utils/ProjectType.ts";
import sharedStyles from "./music-shared.module.css";


export default function Mornings() {



    return (
        <ProjectCard projectName={"One Too Many Mornings"} >

            <ProjectHeader title="ONE TOO MANY MORNINGS" subTitle="Jan" projectType={ProjectType.Music} />

            <p>I feel like “One Too Many Mornings” is often overshadowed by “Don’t Think Twice, It’s All Right”, which explores similar themes and emotions but with a more uplifting tone. But Dylan’s voice in “One Too Many Mornings”, and the lyrics, feel so authentically tired, honest, raw, vulnerable. The guitar is so intimate and humble and soft. I get lost in the atmosphere of it. </p>

            <iframe className={sharedStyles.video} src="https://www.youtube.com/embed/Wnk1Z3k6P2U" title="One Too Many Mornings (Bob Dylan) | Cover by Jan" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>

        </ProjectCard>
    )
}